// extracted by mini-css-extract-plugin
export default {"icon":"ContactDetail_icon__muJ1Y"};